<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.bank_info')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
      <template #right>
        <div class="right" @click="$router.push({ path: '/BindCard' })">{{ $t('setting.add_bank') }}</div>
      </template>
    </van-nav-bar>
    <div class="wrapper">
      <div v-if="!is_bind" class="add-card" @click="toBindCard()">
        <van-icon name="plus" />
        <span>{{ $t('setting.add_bank') }}</span>
      </div>
      <div v-else class="bank">
        <div class="info">
          <div class="row-content">{{ $t('common.exchange_bank') }}: {{ bankInfo.bankinfo }}</div>
          <div class="row-content">{{ $t('setting.username') }}: {{ userInfo.name }}</div>
          <div class="row-content">{{ $t('setting.band_account') }}: {{ bankInfo.bankid }}</div>
        </div>
        <div v-if="bankInfo.type > 1">
          <img class="bank-image" :src="bankInfo.bank_image" />
        </div>
      </div>
      <div class="tips">{{ $t('setting.bind_bank_tip') }}</div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      is_bind: false,
      bankInfo: {},
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.is_bind = true;
            this.bankInfo = res.data.info;
          } else {
            this.is_bind = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.name = res.data.name;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    toBindCard() {
      this.$router.push({ path: '/BindCard' })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.van-cell {
  font-size: 35px;
  line-height: 80px;
}

.bank-image {
  max-width: 100%;
}

.wrapper {
  display: block;
  border-radius: .21333rem;
  flex-direction: row;
  align-items: center;
  background-color: #342f46;
  padding: .21333rem .37333rem;
  margin: 20px;
}

.nav-bar {
  background: linear-gradient(270deg, #323795, #4c206f);
}

::v-deep .nav-bar .van-nav-bar__content {
  height: 100px;
}

::v-deep .nav-bar .van-nav-bar__title {
  max-width: calc(100% - 260px);
  font-size: 27px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nav-bar .right {
  min-width: 150px;
  height: 56px;
  padding: 0 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  border-radius: 16px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  background: rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.14);
  backdrop-filter: blur(8px);
  white-space: nowrap;
  line-height: 1;
}

.container p {
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}

.manage-card .wrapper {
  height: calc(100% - 10px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.wrapper .add-card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: linear-gradient(180deg, #323795, #4c206f);
  height: 250px;
}

.wrapper .add-card span {
  margin-left: 10px;
  font-size: 30px;
}

.wrapper .tips {
  margin: 15px 15px;
  font-size: 25px;
  color: #979799;
}

.wrapper .bank .info {
  margin-left: 20px;
  flex: 1;
  color: #fff;
}

.wrapper .bank .info .row-content {
  margin: 30px 0;
  line-height: 20px;
  font-size: 30px;
}
</style>
